/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EstimateBillingFromPageCounts200ResponseDocumentsInner } from './EstimateBillingFromPageCounts200ResponseDocumentsInner';
import {
    EstimateBillingFromPageCounts200ResponseDocumentsInnerFromJSON,
    EstimateBillingFromPageCounts200ResponseDocumentsInnerFromJSONTyped,
    EstimateBillingFromPageCounts200ResponseDocumentsInnerToJSON,
    EstimateBillingFromPageCounts200ResponseDocumentsInnerToJSONTyped,
} from './EstimateBillingFromPageCounts200ResponseDocumentsInner';

/**
 * Credit and cost estimate from page counts
 * @export
 * @interface EstimateBillingFromPageCounts200Response
 */
export interface EstimateBillingFromPageCounts200Response {
    /**
     * 
     * @type {number}
     * @memberof EstimateBillingFromPageCounts200Response
     */
    totalCredits: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateBillingFromPageCounts200Response
     */
    totalCostCents: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateBillingFromPageCounts200Response
     */
    totalPages: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateBillingFromPageCounts200Response
     */
    costPerCreditCents: number;
    /**
     * 
     * @type {string}
     * @memberof EstimateBillingFromPageCounts200Response
     */
    tierCode: string;
    /**
     * 
     * @type {Array<EstimateBillingFromPageCounts200ResponseDocumentsInner>}
     * @memberof EstimateBillingFromPageCounts200Response
     */
    documents: Array<EstimateBillingFromPageCounts200ResponseDocumentsInner>;
}

/**
 * Check if a given object implements the EstimateBillingFromPageCounts200Response interface.
 */
export function instanceOfEstimateBillingFromPageCounts200Response(value: object): value is EstimateBillingFromPageCounts200Response {
    if (!('totalCredits' in value) || value['totalCredits'] === undefined) return false;
    if (!('totalCostCents' in value) || value['totalCostCents'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('costPerCreditCents' in value) || value['costPerCreditCents'] === undefined) return false;
    if (!('tierCode' in value) || value['tierCode'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function EstimateBillingFromPageCounts200ResponseFromJSON(json: any): EstimateBillingFromPageCounts200Response {
    return EstimateBillingFromPageCounts200ResponseFromJSONTyped(json, false);
}

export function EstimateBillingFromPageCounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateBillingFromPageCounts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCredits': json['totalCredits'],
        'totalCostCents': json['totalCostCents'],
        'totalPages': json['totalPages'],
        'costPerCreditCents': json['costPerCreditCents'],
        'tierCode': json['tierCode'],
        'documents': ((json['documents'] as Array<any>).map(EstimateBillingFromPageCounts200ResponseDocumentsInnerFromJSON)),
    };
}

export function EstimateBillingFromPageCounts200ResponseToJSON(json: any): EstimateBillingFromPageCounts200Response {
    return EstimateBillingFromPageCounts200ResponseToJSONTyped(json, false);
}

export function EstimateBillingFromPageCounts200ResponseToJSONTyped(value?: EstimateBillingFromPageCounts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCredits': value['totalCredits'],
        'totalCostCents': value['totalCostCents'],
        'totalPages': value['totalPages'],
        'costPerCreditCents': value['costPerCreditCents'],
        'tierCode': value['tierCode'],
        'documents': ((value['documents'] as Array<any>).map(EstimateBillingFromPageCounts200ResponseDocumentsInnerToJSON)),
    };
}

